"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  Activity,
  Building2,
  CreditCard,
  LayoutDashboard,
  ScrollText,
  Shield,
  Users,
  QrCode,
  Gamepad2,
  Server,
} from "lucide-react";

import { cn } from "@/lib/utils";

const nav = [
  { href: "/", label: "Dashboard", icon: LayoutDashboard },
  { href: "/merchants", label: "Merchants", icon: Building2 },
  { href: "/customers", label: "Customers", icon: Users },
  { href: "/sessions", label: "Sessions", icon: Gamepad2 },
  { href: "/qr-campaigns", label: "QR Campaigns", icon: QrCode },
  { href: "/audit", label: "Audit Log", icon: ScrollText },
  { href: "/billing", label: "Billing", icon: CreditCard },
  { href: "/server", label: "Server Health", icon: Server },
];

export function AdminSidebar({
  className,
  onNavigate,
}: {
  className?: string;
  onNavigate?: () => void;
}) {
  const pathname = usePathname();

  return (
    <aside
      className={cn(
        "flex w-56 shrink-0 flex-col border-r border-sidebar-border bg-sidebar text-sidebar-foreground",
        className
      )}
    >
      <div className="flex h-14 items-center gap-2 border-b border-sidebar-border px-4">
        <Shield className="size-5 text-sidebar-primary" aria-hidden />
        <div className="flex flex-col leading-tight">
          <span className="text-sm font-semibold tracking-tight">GameIt</span>
          <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
            Backoffice
          </span>
        </div>
      </div>
      <nav className="flex flex-1 flex-col gap-0.5 p-2">
        {nav.map(({ href, label, icon: Icon }) => {
          const active = pathname === href || pathname.startsWith(href + "/");
          return (
            <Link
              key={href}
              href={href}
              onClick={onNavigate}
              className={cn(
                "flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                active
                  ? "bg-sidebar-accent text-sidebar-accent-foreground"
                  : "text-sidebar-foreground/80 hover:bg-sidebar-accent/60 hover:text-sidebar-accent-foreground"
              )}
            >
              <Icon className="size-4 shrink-0 opacity-80" />
              {label}
            </Link>
          );
        })}
      </nav>
      <p className="border-t border-sidebar-border p-3 text-[10px] leading-snug text-muted-foreground">
        GameIt Admin Panel v1.0
      </p>
    </aside>
  );
}
